import { TaskItemDTO } from '@src/services/brain/modules/v1/tasks/dto/brain-tasks.get.response.dto';
import { TFullTaskData, TTaskItem } from './dto/taskItem.dto';
import { GetByIdTaskDTO } from '@src/services/brain/modules/v1/tasks/dto/brain-tasks.getById.response.dto';

export const TasksItemMapper = (task: TaskItemDTO): TTaskItem => {
  return {
    id: task.id,
    createdAt: task.createdAt,
    completedAt: task.completedAt,
    completedByUserId: task.completedByUserId,
    assignedUserId: task.assignedUserId,
    status: task.status,
    source: task.source,
    type: task.type,
    message: task.message,
    organizationId: task.organizationId,
  };
};

export const TasksByIdMapper = (task: GetByIdTaskDTO): TFullTaskData => {
  return {
    id: task.id,
    createdAt: task.createdAt,
    completedAt: task.completedAt,
    completedByUserId: task.completedByUserId,
    assignedUserId: task.assignedUserId,
    status: task.status,
    source: task.source,
    type: task.type,
    message: task.message,
    details: task.details,
    comments: task.comments,
    organizationId: task.organizationId,
  };
};
